module.exports = __webpack_public_path__ + "img/ltLogo.c78670af.png";